import React from "react";
import _ from "lodash";

import { withApollo } from "react-apollo";
import withStyles from "material-ui/styles/withStyles";

import { getModelsQuery, getModelData, getFkData} from "../graph";
import { adminStyle } from "../style";


import Select from "react-select";
import ReactTable from "react-table";

// creative tim components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";
import IconCard from "components/Cards/IconCard.jsx";

// material ui icons
import PeopleIcon from "@material-ui/icons/People";
import AddToPhotos from "@material-ui/icons/AddToPhotos";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Call from "@material-ui/icons/Call";
import DashboardIcon from "@material-ui/icons/Dashboard";
import List from "@material-ui/icons/List";
import NoteAdd from "@material-ui/icons/NoteAdd";
import Pageview from "@material-ui/icons/Pageview";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from "@material-ui/icons/Edit";

import IconButton from "components/CustomButtons/IconButton";
import {roles} from "../constants.js"
// other components 
import AdminCreate from "./AdminCreate.jsx";
import SweetAlertConfirm from "../../etc/modals/SweetAlertConfirm.jsx";

class Admin extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            selectedModel: "",
            data: [],
            columns: [],
            options: [],
            models: [],
            loading: false,
            createLoading: false,
            updateLoading: false,
            createModalIsOpen: false,
            updateModalIsOpen: false,
            deleteModalIsOpen: false,
            schema: {},
            uiSchema: {},
            formData: {},
            mode: null,
            pkeys: [], 
            offset: 0, 
            pageSize: 10
        }
        this.schemaTemplate = {
            type: "object",
            properties: {}
        }
    }
    // Update select options for model selection
    componentDidUpdate(prevProps, prevState){
        if(this.props.getModelsQuery.loading === false && _.isEmpty(this.state.options)){
            let options = [];
            let models = JSON.parse(this.props.getModelsQuery.getModels);
            Object.keys(models).map((key, index) => {
                options.push({label: key, value: key});
            });
            this.setState({
                options: options,
                models: models
            });
        }
    }
    // handle change on select model
    handleChange = (event) => {
        const value = event.value;
        this.setState({ selectedModel: value });
        this.getData(value)
    }
    openUpdateModal = (data, event) => {
        const columns = this.state.models[this.state.selectedModel];
        this.setState({updateLoading: true});
        const [model, uiSchema, hasFk, pkeys] = this.setForm(columns, "update");
        this.schemaTemplate["properties"] = model;

        let updateData = {};
        updateData = Object.assign(updateData, data);
        if (updateData.role !== undefined){
            updateData.role = roles[updateData.role];
        }

        (hasFk) ?
        this.setState({
            updateModalIsOpen: true,
            schema: this.schemaTemplate,
            uiSchema: uiSchema,
            formData: updateData,
            pkeys: pkeys
        }) : 
        this.setState({
            updateModalIsOpen: true,
            schema: this.schemaTemplate,
            uiSchema: uiSchema,
            updateLoading: false,
            formData: updateData,
            pkeys: pkeys
        }); 
    }
    closeUpdateModal = (event) => {
        this.setState({
            updateModalIsOpen: false,
            formData: {}
        });
    }
    onSubmitUpdate = (formData) => {
        const columns = this.state.models[this.state.selectedModel];

        this.props.entryCud({
            variables: {
                data: JSON.stringify(formData.formData),
                className: this.state.selectedModel,
                actionType: "update",
                primaryKeys: JSON.stringify({keys: this.state.pkeys})
            }
        }).then((data) => {
            this.setState({
                updateModalIsOpen: false
            });
            this.getData(this.state.selectedModel);
            alert("Entry updated!");
        }).catch((error) => {
            alert("Error! check console for info");
            this.setState({
                formData: formData.formData
            });
            console.log(error);
        });
    }
    openCreateModal = (event) =>{
        const columns = this.state.models[this.state.selectedModel];

        this.setState({
            createLoading: true
        });

        const [model, uiSchema, hasFk, pkeys] = this.setForm(columns, "create");
        this.schemaTemplate["properties"] = model;

        // remove loading if table has no foreign key
        (hasFk) ?
        this.setState({
            createModalIsOpen: true,
            schema: this.schemaTemplate,
            uiSchema: uiSchema
        }) : 
        this.setState({
            createModalIsOpen: true,
            schema: this.schemaTemplate,
            uiSchema: uiSchema,
            createLoading: false
        }); 
    }
    closeCreateModal = (event) => {
        this.setState({
            createModalIsOpen: false,
            formData: {}
        });
    }
    onSubmitCreate = (formData) => {
        this.props.entryCud({
            variables: {
                data: JSON.stringify(formData.formData),
                className: this.state.selectedModel,
                actionType: "create"
            }
        }).then((data) => {
            this.setState({
                createModalIsOpen: false
            });
            this.getData(this.state.selectedModel);
            alert("Entry added!");
        }).catch((error) => {
            alert("Error! check console for info");
            this.setState({
                formData: formData.formData
            });
            console.log(error);
        });
    }
    openDeleteModal = (data,event) => {
        this.setState({deleteModalIsOpen: true, formData: data})
    }
    closeDeleteModal = (event) => {
        this.setState({deleteModalIsOpen: false, formData: {}});
    }
    onSubmitDelete = (event) => {
        const columns = this.state.models[this.state.selectedModel];
        let pkeys = [];
        columns.map((column, index) => {
            (Object.values(column)[0] === "PK") ? pkeys.push(Object.keys(column)[0]) : null;
        })

        this.props.entryCud({
            variables: {
                data: JSON.stringify(this.state.formData),
                className: this.state.selectedModel,
                actionType: "delete",
                primaryKeys: JSON.stringify({keys: pkeys})
            }
        }).then((data) => {
            this.setState({
                deleteModalIsOpen: false,
                formData: {}
            });
            this.getData(this.state.selectedModel);
            alert("Entry deleted!");
        }).catch((error) =>{
            console.log(error);
            alert("Error in deleting data, check console");
        });
    }
    // Creates rows for the react table
    createDataObject = (data) => {
        let dataObject = {};

        Object.keys(data).map((key, index)=> {
            dataObject[key] = data[key];
        });

        dataObject["actions"] = (
                <div className="actions-right">
                    <Tooltip
                        id="tooltip-top"
                        title="Update"
                        placement="top"
                    >
                        <IconButton
                            onClick={this.openUpdateModal.bind(this,data)}
                            color="primary"
                        >
                        <EditIcon />
                        </IconButton>
                    </Tooltip>
                </div>)
        return dataObject;
        // disabling this temporarily
        // <Tooltip
        //     id="tooltip-top"
        //     title="Delete"
        //     placement="top"
        // >
        //     <IconButton
        //         onClick={this.openDeleteModal.bind(this,data)}
        //         color="rose"
        //     >
        //     <DeleteIcon />
        //     </IconButton>
        // </Tooltip>{" "}
    }
      

    // Creates columns for react table
    createColumns(columns){
        let cols = [];
        columns.map((column, index) => {
            let key = Object.keys(column)[0];
            cols.push({Header: key, accessor: key});
        });
        const actions = {
          Header:"Actions",
          accessor:"actions",
          minWidth: 200,
          sortable:false,
          filterable:false
        };
        cols.push(actions);

        return cols
    }
    getData(value){
        this.setState({ loading: true })
        this.props.client.query({
            query: getModelData,
            fetchPolicy: "network-only",
            variables: {
                className: value, 
                offset: this.state.offset, 
                pageSize: this.state.pageSize
            }
        }).then((data) => {
            let d = JSON.parse(data.data.getModelData)
            // Get column names
            const cols = this.createColumns(this.state.models[value]);
            this.setState({
                columns: cols,
                data: d.data,
                loading: false, 
                pages: d.pages
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    fetchData(state=null, instance=null){
        /*
            this function is called when the next, previous button is clicked on reactTable
        */
        if (state){
            this.setState({
                offset: state.page,
                pageSize: state.pageSize
            }, () => this.getData(this.state.selectedModel))
        }
    }
    // Set form for react-json-schema-form
    setForm(columns, mode){
        let model = {};
        let uiSchema = {};
        let hasFk = false;
        let pkeys = [];

        mode = (mode === "create") ? "createLoading" : "updateLoading";
        columns.map((column, index) => {
            let key = Object.keys(column)[0];
            let type = column[key];
            let property = {};

            if(type.includes("INTEGER")){
                property["type"] = "integer";
            }
            else if(type.includes("PK")){
                property["type"] = "integer";
                // Add primary keys to an array for query later
                pkeys.push(key);
            }
            else if(type.includes("Enum")){
                property["type"] = "integer";
                property["enum"] = Object.values(roles);
                property["enumNames"] = Object.keys(roles);
            }
            // Get max length for varchar
            else if(type.includes("VARCHAR")){
                property["maxLength"] = _.parseInt(type.replace( /^\D+/g, ''));
                property["type"] = "string";
                // Removed password cover in form
                /* if(key.includes("password")){
                     uiSchema[key] = {"ui:widget" : "password"};
                 } */
            }
            else if(type.includes("JSON")){
                property["type"] = "string"
            }
            else if(type.includes("BOOLEAN")){
                property["type"] = "boolean";
            }
            else if(type.includes("DATETIME")){
                property["type"] = "string";
                uiSchema[key] = {"ui:widget": "date-time"};
            }
            // type is foreign key
            else if(type.includes("FK-")){
                property["type"] = "integer";
                hasFk = true;
                this.setState({
                    [mode]: true
                });
                // Get all the values of the foreign key
                this.props.client.query({
                    query: getFkData,
                    variables: {
                        model: type.split("-")[1],
                        column: key
                    },
                    fetchPolicy: "network-only",
                    errorPolicy: "all"
                }).then((data) => {
                    property["enum"] = JSON.parse(data.data.getFkData);
                    model[key] = property;
                    this.schemaTemplate["properties"] = model;
                    this.setState({
                        schema: this.schemaTemplate,
                        [mode]: false
                    });
                }).catch((error) => {
                    console.log(error);
                });
            }
            model[key] = property;
        });
        return [model, uiSchema, hasFk, pkeys];
    }
    validate = (formData, errors) => {
        console.log(formData, errors, "VALIDATE");
        //errors.username.addError("Error");
        return errors
    }
    render(){
        const { selectedModel, data, columns, options, loading, createModalIsOpen, 
            updateModalIsOpen,deleteModalIsOpen,models, schema, uiSchema, createLoading, updateLoading,
            pages } = this.state;
        const { classes } = this.props;
        const createModal = createModalIsOpen ? <AdminCreate 
                                isOpen={createModalIsOpen}
                                onCloseModal = {this.closeCreateModal}
                                formData = {this.state.formData}
                                columns={models[selectedModel]}
                                schema={schema}
                                uiSchema={uiSchema}
                                onSubmit={this.onSubmitCreate}
                                validate={this.validate}
                                loading={createLoading}
                            /> : null;
        const updateModal = updateModalIsOpen ? <AdminCreate 
                                isOpen={updateModalIsOpen}
                                onCloseModal={this.closeUpdateModal}
                                formData = {this.state.formData}
                                columns={models[selectedModel]}
                                schema={schema}
                                uiSchema={uiSchema}
                                onSubmit={this.onSubmitUpdate}
                                validate={this.validate}
                                loading={updateLoading}
                            /> : null;

        const deleteModal = deleteModalIsOpen ? <SweetAlertConfirm
                                onConfirm={this.onSubmitDelete}
                                confirmBtnMsg="Delete"
                                onClose={this.closeDeleteModal}
                                type="error"
                                message={<p>Are you sure you want to delete this entry?</p>}
                                headerTitle="Delete Entry"
                            /> : null;

        return(
            <GridContainer>
                {createModal}
                {updateModal}
                {deleteModal}
                <ItemGrid xs={12}>
                    <IconCard
                        icon={ PeopleIcon }
                        title="Admin"
                        content={
                            <GridContainer>
                                <ItemGrid xs={12} md={4}>
                                    <Select
                                        onChange={this.handleChange}
                                        options={options}
                                        value={selectedModel}
                                        placeholder="Select Table"
                                        clearable={false}
                                    />
                                </ItemGrid>
                                <ItemGrid xs={12}>
                                    <Button
                                        size="lg"
                                        color="primary"
                                        onClick={this.openCreateModal.bind(this)}
                                        disabled={(selectedModel) ? false : true}
                                    >
                                        Create
                                    </Button>
                                    <ReactTable
                                        manual
                                        pages={pages}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        filterable
                                        data={
                                            this.state.data.map((table, key) => {
                                                return(
                                                    this.createDataObject(table)
                                                )
                                            })
                                        }
                                        loading={loading}
                                        columns={columns}
                                        defaultPageSize={10}
                                        onFetchData={this.fetchData.bind(this)}
                                    />
                                </ItemGrid>
                            </GridContainer>
                        }
                    />
                </ItemGrid>
            </GridContainer>
        )
    }
}


export default withStyles(adminStyle)((getModelsQuery)(withApollo(Admin)))


// WEBPACK FOOTER //
// ./src/views/admin/components/Admin.jsx